const remToPx = (rem) => {
  let screenW =
    document.documentElement.clientWidth > 750
      ? 750
      : document.documentElement.clientWidth;
  return (rem * 100 * screenW) / 750;
};

export default remToPx;
